import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { profile } from 'routes/route.map'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Text } from 'shared/components'

import * as styles from './styles'

const BalanceAccessComponent = ({
  appStore,
  isLoadingTotalInWins,
  loadTotalInWins,
  loadTotalBalance,
  isVisible,
  displayInwins,
}) => {
  const { loggedEntity } = appStore.auth
  const { items: inwins } = appStore.inwins
  const wallet = loggedEntity?.wallet

  useEffect(() => {
    if (loggedEntity) {
      const getData = async () => {
        await loadTotalInWins()
        await loadTotalBalance()
      }
      getData()
    }
  }, [loggedEntity])

  return (
    <>
      {!!loggedEntity && !isLoadingTotalInWins && isVisible && (
        <div style={{ display: 'flex', gap: 8 }}>
          <Link
            to={profile.inwins()}
            css={[styles.link, displayInwins ? {} : styles.inWinsLink]}
          >
            <Text size={11}>
              Placed InWins:
              <span css={styles.count}> {inwins?.size || 0}</span>
            </Text>
          </Link>
          <Link to={profile.balance()} css={styles.link}>
            <Text size={11}>
              Balance: <span css={styles.count}> ${wallet.balance}</span>
            </Text>
            <FontAwesomeIcon size="1x" icon="plus" css={styles.plus} />
          </Link>
        </div>
      )}
    </>
  )
}

BalanceAccessComponent.propTypes = {
  appStore: PropTypes.shape().isRequired,
  isLoadingTotalInWins: PropTypes.bool.isRequired,
  loadTotalInWins: PropTypes.func.isRequired,
  loadTotalBalance: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
  displayInwins: PropTypes.bool,
}

export default observer(BalanceAccessComponent)
